import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.useEnvFile) {
  // Read client base url from env.json
  fetch('./env.json').then(
    (res) => {
      res.json().then((json) => {
        console.log('Client Base URL', json);

        // Set client base url
        environment.endpoints.clientBaseUrl = json.clientBaseUrl;

        // Bootstrap application
        bootstrap();
      });
    },
    (err) => {
      console.error('Failed to fetch env.json', err);
    });
} else {
  bootstrap();
}

function bootstrap() {
  if (environment.production) {
    enableProdMode();
  }

  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
}
